import { type UpdateResolver } from "@urql/exchange-graphcache";
import { gql } from "urql";

import {
  type CreateInvitationInput,
  type CreateInvitationPayload,
  type Maybe,
} from "@/gql/graphql";

type Args = { input: CreateInvitationInput };
type Result = Maybe<{ createInvitation: Maybe<CreateInvitationPayload> }>;

const updater: UpdateResolver<Result, Args> = (result, args, cache) => {
  if (result?.createInvitation?.invitation) {
    cache.updateQuery(
      {
        query: gql`
          query OrganizationInvitationsGql($organizationId: String!) {
            organization(id: $organizationId) {
              id
              invitations {
                nodes {
                  id
                }
              }
            }
          }
        `,
        variables: {
          organizationId: args.input.organizationId,
        },
      },
      (data) => {
        data.organization.invitations.nodes = [
          ...data.organization.invitations.nodes,
          result.createInvitation?.invitation,
        ];
        return data;
      },
    );
  }
};

export const createInvitation = updater as unknown as UpdateResolver;
